import ScrollToTop from "./Components/ScrollTop";
import { Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./Services/LanguageContext.js";
import { AuthProvider } from "./contexts/JWTAuthContext";
import User from "./Layout/User";
import { Fragment } from "react";
import AboutUs from "./Views/User/AboutUs/AboutUs";
import Dashboard from "./Views/Dashboard";
import Meeting from "./Views/Meeting";
import MeetingListings from "./Views/MeetingListings";
import Other from "./Views/Other";
import Orientation from "./Views/Orientation";
import OrientationsListings from "./Views/OrientationsListings";
import QRPage from "./Views/QRPage";
import ReservationsListings from "./Views/ReservationsListings";
import ClientFeedback from "./Views/ClientFeedback";
import UnitPayment from "./Views/UnitPayment";
import Leads from "./Views/Leads";
import ReservationDetails from "./Views/ReservationDetails";
function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Fragment>
          <ScrollToTop />
          <Routes>
            {/* <Route path="/" element={<User />} />
            <Route path="/about-us" element={<AboutUs />} /> */}
            <Route path="/reservation" element={<ReservationDetails />} />
            <Route path="/orientation/:salesId" element={<Orientation />} />
            <Route path="/orientations-listings" element={<OrientationsListings />} />
            <Route path="/qr" element={<QRPage />} />
            <Route path="/*" element={<User />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/unit-payment/:unitId/:view?" element={<UnitPayment />} />
            <Route path="/meeting" element={<Meeting />} />
            <Route path="/meeting-listings" element={<MeetingListings />} />
            <Route path="/reservations-listings" element={<ReservationsListings />} />
            <Route path="/other" element={<Other />} />
            <Route path="/feedback/:userId" element={<ClientFeedback />} />
            <Route path="/leads" element={<Leads />} />
          </Routes>
        </Fragment>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
